import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/AGE_GROUPS';
export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    institutionId => ({institutionId}),
    (ageGroups, institutionId, behaviors) => ({ageGroups, institutionId, behaviors}),
);

export const {
    action: createAll,
    success: createAllSuccess,
    failed: createAllFailed,
} = createAction(
    `${domain}/CREATE_ALL`,
    (institutionId, ageGroups) => ({institutionId, ageGroups}),
    (institutionId, ageGroups) => ({institutionId, ageGroups}),
);

export const {
    action: updateAll,
    success: updateAllSuccess,
    failed: updateAllFailed,
} = createAction(
    `${domain}/UPDATE_ALL`,
    (institutionId, ageGroups) => ({institutionId, ageGroups}),
    (institutionId, ageGroups) => ({institutionId, ageGroups}),
);
